import { atom, selector } from 'recoil'
import { MESSAGE_BOX_VARIANT_WARNING } from 'mailup-web-components'
import { MESSAGE_STR_TYPE_CONTENTSCAMPAIGN } from 'Constants/'

export const pageState = atom({
  key: 'messageCheckupLinkCheckPageState',
  default: {
    loaded: false,
    loading: false,
    error: false,
    isBee: false,
    id: undefined,
    messageType: undefined,
    severity: MESSAGE_BOX_VARIANT_WARNING,
    title: undefined
  }
})

export const canSendState = selector({
  key: 'messageCheckupLinkCheckCanSendState',
  get: ({ get }) => {
    const { messageType } = get(pageState)

    return messageType && messageType !== MESSAGE_STR_TYPE_CONTENTSCAMPAIGN
  }
})
